import { Routes } from '@angular/router';

export enum RoutePathEnum {
  INBOX_GRID = 'inbox-grid',
  EMAIL_PROCESSING = 'emails/:emailId',
}

export const routes: Routes = [
  {
    path: 'inbox',
    title: 'INBOX_GRID.LBL_PAGE_TITLE',
    loadComponent: () => import('./features/inbox-grid/inbox-grid.component').then(mod => mod.InboxGridComponent),
  },
  {
    path: 'emails/:emailId',
    title: 'EMAIL_PROCESSING.LBL_PAGE_TITLE',
    loadComponent: () => import('./features/email-processing/email-processing.component').then(mod => mod.EmailProcessingComponent),
  },
  {
    path: '**',
    redirectTo: 'inbox',
  },
];
